<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerIconRetina from 'leaflet/dist/images/marker-icon-2x.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import PartnerApi from "@/services/partner-api";
import CountriesApi from "@/services/countries-api";
import CampaignApi from "@/services/campaign-api";
import CampaignTargetsPartner from "@/router/views/partner/campaign-targets-partner";
import 'leaflet.markercluster';
export default {
  name: 'MyMapComponent',
  components: {CampaignTargetsPartner},

  props : {
    sector:{
          type:Array,
          default: () => [],
      },
    fromMenu:{
        type:Boolean,
        default: true
      },
    campaign:{
        type:Object,
        default: () => null,
    },
  
    },

  data() {
    return {

      options: [],
      selectedOptions: [],
      filteredMarkers:[],

      defaultIcon: L.icon({
        iconUrl: markerIcon,
        iconRetinaUrl: markerIconRetina,
        shadowUrl: markerShadow,
        iconSize: [25, 35], 
        iconAnchor: [12, 41], 
        popupAnchor: [1, -34], 
        shadowSize: [10, 10],
      }),

      clusteringMarkerIcon: L.icon({
        iconUrl: require("@/assets/icons/marker.png"),
        shadowUrl: markerShadow,
        iconSize: [20, 31], 
        iconAnchor: [12, 41], 
        popupAnchor: [1, -34], 
        shadowSize: [10, 10],  
      }),

      filteredPharmaIcon: L.icon({
        iconUrl: require("@/assets/icons/pharmaMarker.png"),
        shadowUrl: markerShadow,
        iconSize: [20, 31], 
        iconAnchor: [12, 41], 
        popupAnchor: [1, -34], 
        shadowSize: [10, 10],  
      }),

      markers: [],
      allMarkers: [],

      citiesList:[],
      countriesList:[],
      selectedCountry:null,
      selectedCity:[],
      filterByNear:null,

      sectorsList:null,
      selectedSectorsList:[],
      campaignDetails:null,

      bounds: null ,
      zoomLevel: null,
      keySelectedCount:0,
      keySectorSelectedCount:0,

      selectedCitiesCount:null,
      selectedSectorCount:null,
      partnerStatusList:null,
      selectedPartnerStatus:null
    };
  },

  mounted() {


    this.getCountries()
    this.initializeMap()

    this.getNearOptions()

    this.selectedSectorsList = this.sector 

    this.getSector()
    this.findAllPartnerStatus()
    
    

  },


  watch: {
    'campaign.radius'(newRadius) {
      if (this.currentCircle) {
        this.updateCircleRadius(newRadius);
        this.filterMarkers()

      }
    },
    'campaign.latitude'() {
      if (this.campaign && this.campaign.latitude && this.campaign.longitude) {
        this.addCircle([this.campaign.latitude, this.campaign.longitude]);
        this.filterMarkers()

      }
    },
    'campaign.longitude'() {
      if (this.campaign && this.campaign.longitude && this.campaign.latitude) {
        this.addCircle([this.campaign.latitude, this.campaign.longitude]);
        this.filterMarkers()
      }
    },
        selectedCountry: function(){
          if(this.selectedCountry != null){
            this.getCities()
          }else{
              this.citiesList=[]
          }
          this.filterMarkers()

        },
        
        selectedSectorsList: function(){
            this.filterMarkers()
        },

        selectedCity: function(){
            this.filterMarkers()
        },

        campaign: function(){
            if(this.campaign){
            this.campaignDetails = this.campaign
            this.selectedCity = this.campaignDetails.cityDTOS	
            this.selectedCountry = this.campaignDetails.countryDTO	
            this.selectedOptions	 = this.campaignDetails.partnerNearsList	
            if (Array.isArray(this.campaignDetails.sectorList)) {
              this.campaignDetails.sectorList.forEach(s => {
                this.selectSector(s);
              });
            }

            if(this.campaign && this.campaign.radius && this.campaign.latitude && this.campaign.longitude ){
              this.addCircle([this.campaign.latitude, this.campaign.longitude])
            }

        }
        }
    },

    computed: {
        isSectorSelected() {
            return (sector = null) => {
              if(this.selectedSectorsList == null || this.selectedSectorsList.length == 0  ){
                return false
              }

                const sectorCodes = this.selectedSectorsList.map(ss => ss.code);

                this.selectedSectorsList.map(ss =>{ ss.code})
                return sectorCodes.includes(sector.code);
            };
        }
    },



  methods: {
    updateCircleRadius(newRadius) {
      if (this.currentCircle) {
        this.currentCircle.setRadius(newRadius);
      }
    },

    findAllPartnerStatus(){
      PartnerApi.findAllPartnerStatus().then(partnerStatusList =>{
            if(partnerStatusList){
                this.partnerStatusList = partnerStatusList
            }
        })
    },

    refrechCountSelected(selectedCitiesCount , selectedSectorCount) {
            this.selectedCitiesCount = selectedCitiesCount;
            this.selectedSectorCount = selectedSectorCount;
            this.keySectorSelectedCount++
        },

    selectSector(value) {
      if (!Array.isArray(this.selectedSectorsList)) {
          this.selectedSectorsList = [];
      }

      const index = this.selectedSectorsList.findIndex(ss => ss.code === value.code);

      if (index === -1) {
          this.selectedSectorsList.push(value);
      } else {
          this.selectedSectorsList.splice(index, 1);
      }
    },


    getSector(){
        CampaignApi.getSector().then(sector =>{
            if(sector){
                this.sectorsList = sector
            }
        })
    },

    getCountries(){
       CountriesApi.getCountries().then(
          result => {
            this.countriesList = result
        })
     },
    getCities(){
       CountriesApi.getCities(this.selectedCountry ? this.selectedCountry.id : this.campaignDetails.country != null ? this.campaignDetails.country.id : null).then(
          result => {
            this.citiesList = result
        })
     },

    getNearOptions() {
      PartnerApi.getNearOptions().then(result => {
        if (result) {
        this.options = result; 
        }
      });
    },


    findAllPartner(){

      PartnerApi.findAllPartner(this.bounds.getSouth(),this.bounds.getNorth(),this.bounds.getWest(),this.bounds.getEast(),this.zoomLevel).then(result => {
        if(result){
          this.allMarkers = result

          this.loadMarkers()

        }
      })
    },
    initializeMap() {
      const isMobile = window.innerWidth <= 768;
      const latLng = isMobile ? [34.7589023, 9.3267611] : [34.7236, 3.2794];

      this.map = L.map('mi_mapa').setView(latLng, 6);

    const osmLayer = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        minZoom:6,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    });


      const worldImagery = L.tileLayer(
        'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
          maxZoom: 19,
          attribution: 'Imagery &copy; <a href="https://www.esri.com/">Esri</a>'
        }
      );

      const referenceLayer = L.tileLayer(
        'https://services.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}', {
          maxZoom: 19,
          attribution: 'Labels & boundaries &copy; <a href="https://www.esri.com/">Esri</a>'
        }
      );

      const transport = L.tileLayer(
        'https://services.arcgisonline.com/ArcGIS/rest/services/Reference/World_Transportation/MapServer/tile/{z}/{y}/{x}',
        { maxZoom: 19, attribution: 'Esri Transportation…' }
      );


      const satelliteWithLabels = L.layerGroup([worldImagery, referenceLayer, transport ]);

    if(!this.fromMenu){
      this.map.on('click', this.handleMapClick);
    }

    osmLayer.addTo(this.map);

    const baseLayers = {
        "Standard": osmLayer,
        "Satellite": satelliteWithLabels
    };

    L.control.layers(baseLayers).addTo(this.map);

    this.loadPartners();
    this.map.on('moveend', () => {
        this.loadPartners();
    });
},

handleMapClick(event) {
    const { lat, lng } = event.latlng;
    this.campaign.latitude = lat;
    this.campaign.longitude = lng;
    this.addMarker([lat, lng]);

  },

addCircle(position) {
  if (this.currentCircle) {
      this.map.removeLayer(this.currentCircle);
  }

  this.currentCircle = L.circle(position, {
      color: 'blue',
      fillColor: 'blue',
      fillOpacity: 0.2,
      radius: this.campaign && this.campaign.radius ? this.campaign.radius : 0
  }).addTo(this.map);
},

addMarker(position) {
    if (this.currentMarker) {
      this.map.removeLayer(this.currentMarker);
    }

    this.currentMarker = L.marker(position, { icon: this.defaultIcon })
      .addTo(this.map)
      .bindPopup(`${position[0].toFixed(5)}, ${position[1].toFixed(5)}`)
      .openPopup();
  },

loadPartners() {
    this.bounds = this.map.getBounds();
    this.zoomLevel = this.map.getZoom();

    this.findAllPartner();
},

loadMarkers() {
    this.map.eachLayer(layer => {
        if (layer instanceof L.Marker) {
            this.map.removeLayer(layer);
        }
    });

    if(this.allMarkers.features == null){
      return
    }

    this.filteredMarkers = (this.allMarkers?.features || []).filter(marker => {
        const { coordinates } = marker.geometry; 
        const isWithinBounds = this.bounds.contains([coordinates[1], coordinates[0]]);

      var distance = 0 ;
        if(!this.fromMenu){
          distance = this.calculateDistance([this.campaign.latitude, this.campaign.longitude], [coordinates[1], coordinates[0]]);
        }

      const matchesRadius =this.fromMenu ? true : (this.campaign && this.campaign.radius > 0 ? distance <= this.campaign.radius : true)

        const matchesCity = 
            (!this.selectedCity || !this.selectedCity.length || 
            this.selectedCity.some(city => marker.properties.cityName === city.name));
        const matchesCountry = 
            (!this.selectedCountry || marker.properties.countryName === this.selectedCountry.name);
        const matchesSectors = 
            (!this.selectedSectorsList || !this.selectedSectorsList.length || 
             this.selectedSectorsList.some(s => marker.properties.sector === s.sector));
        const matchesOptions = 
            (!this.selectedOptions || !this.selectedOptions.length || 
             this.selectedOptions.some(option => ( marker.properties.nearList.includes(option.key)   ||  marker.properties.nearList.includes(option.near) ) ));     
        return isWithinBounds && matchesRadius && matchesCity && matchesCountry && matchesSectors && matchesOptions;
    });

    L.NumberedDivIcon = L.Icon.extend({
    options: {
        iconUrl: '',
        number: '',
        shadowUrl: null,
        iconAnchor: new L.Point(9.57, 57),
        popupAnchor: new L.Point(0, 28),
        className: 'leaflet-div-icon',
        showCoverageOnHover: true,

    },

    createIcon: function () {
        var div = document.createElement('div');
        var img = this._createImg(this.options.iconUrl);
        var numdiv = document.createElement('div');
        numdiv.setAttribute("class", "number");

        const displayNumber = this.options.number > 99 ? "+99" : this.options.number;
        numdiv.innerHTML = displayNumber || '';

        if (displayNumber === "+99") {
            numdiv.style.fontSize = "10px";
            numdiv.style.padding = "0px 0px";
        } else {
            numdiv.style.fontSize = "11px";
        }

        div.appendChild(img);
        div.appendChild(numdiv);
        this._setIconStyles(div, 'icon');
        return div;
    }
});


this.filteredMarkers.forEach(marker => {
    const { coordinates } = marker.geometry;
    const { name, sector } = marker.properties;

    // For non-Pharmacie markers, use default icon
    if (sector !== "Pharmacie") {
        L.marker([coordinates[1], coordinates[0]], { icon: this.defaultIcon })
            .bindPopup(name)
            .addTo(this.map);
    } 


    if (marker.clusterCount > 1){
      
      const markerIcon = new L.NumberedDivIcon({
            number: marker.clusterCount > 1 ? marker.clusterCount : ''
        });
            L.marker([coordinates[1], coordinates[0]], { icon: markerIcon })
            .addTo(this.map);
    }



});

    // Add other markers to the map without clustering
    const otherMarkers = (this.allMarkers?.features || []).filter(marker => !this.filteredMarkers.includes(marker));
    otherMarkers.forEach(marker => {
        const { coordinates } = marker.geometry;
        const { name } = marker.properties;

        L.marker([coordinates[1], coordinates[0]], { icon: this.clusteringMarkerIcon })
            .bindPopup(name)
            .addTo(this.map);
    });

    // Add pharma markers to the map without clustering
    const pharmaMarkers = (this.allMarkers?.features || []).filter(marker => 
        marker.properties.sector === "Pharmacie" && this.filteredMarkers.includes(marker));
    pharmaMarkers.forEach(marker => {
        const { coordinates } = marker.geometry;
        const { name } = marker.properties;

        L.marker([coordinates[1], coordinates[0]], { icon: this.filteredPharmaIcon })
            .bindPopup(name)
            .addTo(this.map);
    });

    this.$emit('filteredMarkers' ,  this.filteredMarkers,
                                    this.selectedCountry,
                                    this.selectedCity,
                                    this.selectedOptions,
                                    this.selectedSectorsList,
                                    this.campaign && this.campaign.latitude  ?  this.campaign.latitude : null,
                                    this.campaign && this.campaign.longitude  ? this.campaign.longitude : null  ,
                                    this.campaign && this.campaign.radius ? this.campaign.radius : 0);
},

    filterMarkers() {
      this.loadMarkers();
      
    },

    calculateDistance(center, position) {
      const [lat1, lon1] = center;
      const [lat2, lon2] = position;
      
      const R = 6371e3;
      const φ1 = lat1 * Math.PI / 180;
      const φ2 = lat2 * Math.PI / 180;
      const Δφ = (lat2 - lat1) * Math.PI / 180;
      const Δλ = (lon2 - lon1) * Math.PI / 180;

      const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
                Math.cos(φ1) * Math.cos(φ2) *
                Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

      return R * c; 
    }

  },
};
</script>




<template>

  <div class="">

    <!-- <div class="mt-3" v-if="allMarkers && allMarkers.sectorCount">
        <div v-for="(count, sector) in allMarkers.sectorCount" :key="sector">
          {{ count }} <strong class="text-info"> {{ sector }} </strong> {{$t('campaign.text.displayed')}}   zzz
        </div>
    </div>

    <div class="mt-3" v-if="allMarkers && allMarkers.cities">
      <div v-for="(count, city) in allMarkers.cities" :key="city">
        {{ count }}  {{$t('partner.text.displayedPartner')}}   <strong class="text-info"> {{ city }} </strong>
      </div>
    </div> -->


        <div class="row mt-1 text-primary">
        
            <!-- <div class="col-3"/> -->

            <div class="col-12">
              <div :key="keySelectedCount"  v-if="!fromMenu">
                  <div class="" v-if="campaign && campaign.selectedSectorCount">
                    <div v-for="(count, sector) in campaign.selectedSectorCount" :key="sector">
                    <span class="font-size-16"> <strong class="">   {{ count }}  {{ sector }}(s) </strong> {{$t('campaign.text.selected')}} 
                    </span>
                    </div>
                  </div>
              </div>
              <div v-else :key="keySectorSelectedCount">
                  <div class="" v-if="this.selectedSectorCount">
                    <div v-for="(count, sector) in this.selectedSectorCount" :key="sector">
                    <span class="font-size-16"> <strong class="">   {{ count }}  {{ sector }}(s) </strong> {{$t('campaign.text.selected')}} 
                    </span>
                    </div>
                  </div>
              </div>
            </div>

        </div>





           


    <div class="row mt-5">
      <div class="col-12 col-md-3">
          
          


















          
  <div class="text-secondary text-center font-size-16 mt-md-5 mt-2 mb-md-5 mb-2 text-uppercase "> {{fromMenu ? $t('campaign.label.filterpartners') : $t('campaign.label.filter')}} </div>

  <div class="row m-4">

        <div :class="!fromMenu ? 'col-md-12 col-sm-12 col-xs-12 pr-lg-2' : 'col-12 '">
            <b-form-group :label="$t('lists.countries.filter')" label-for="">
                <v-select class="style-vselect-big  font-size-16"  :options="countriesList" :placeholder="$t('lists.countries.label')"  label="name" v-model="selectedCountry" :disabled="!fromMenu && ( campaignDetails == null  ||  campaignDetails.id  == null )  && campaign.campaignWithOutBags ">
                    <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                </v-select>
            </b-form-group>
        </div>
        <div class="mt-2" :class="!fromMenu ? 'col-md-12 col-sm-12 col-xs-12 pr-lg-2' : 'col-12 '">
            <b-form-group :label="$t('lists.cities.filter')"  label-for="">
                <v-select class="style-vselect-big  font-size-16" multiple :options="citiesList" :placeholder="$t('lists.cities.filter')" label="name" v-model="selectedCity" :disabled="!fromMenu &&  ( campaignDetails == null  ||  campaignDetails.id  == null )  && campaign.campaignWithOutBags ">
                    <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                </v-select>
            </b-form-group>
        </div>


        
    <div v-if="options && options.length" class="mt-0" :class="!fromMenu ? 'col-md-12 col-sm-12 col-xs-12 pr-lg-2' : 'col-12 '">

      <div class="text-secondary font-size-14 pt-2 pb-2"> {{$t('campaign.label.near')}} </div>

      <v-select
      :disabled="!fromMenu && ( campaignDetails == null  ||  campaignDetails.id  == null )  && campaign.campaignWithOutBags "
          class="style-vselect-big font-size-16 "
          :options="options"
          :placeholder="$t('campaign.label.near')"
          label="near"
          v-model="selectedOptions"  
          multiple  
          @input="filterMarkers"
      >
          <span class="text-uppercase" slot="no-options">{{$t('lists.emptyLists.label')}}</span>
      </v-select>
    </div>



    <div v-if="sectorsList && sectorsList.length" class="mt-2" :class="!fromMenu ? 'col-md-12 col-sm-12 col-xs-12 pr-lg-2' : 'col-12 '">

      <div class="text-secondary font-size-14 mt-3 pb-2 "> {{$t('campaign.label.sector')}} </div>

      <div v-if="sectorsList && sectorsList.length" class="search-container ">
          <div  v-for="(option , index ) in sectorsList" :key="index">

              <b-form-checkbox 
                 :disabled="!fromMenu && ( campaignDetails == null  ||  campaignDetails.id  == null  )  && campaign.campaignWithOutBags "
                 :checked="isSectorSelected(option)"
                  class="custom-checkbox custom-checkbox-success mb-2 mt-2"
                  @change="selectSector(option)">
                  <span class="font-size-14" :class="isSectorSelected(option)  ? 'text-primary' : ''">{{ option.sector }}</span>
              </b-form-checkbox>
          </div>
          
      </div>

    </div>

    <div v-if="fromMenu && partnerStatusList" class="mt-2col-md-12 col-sm-12 col-xs-12 pr-lg-2">
            <b-form-group :label="$t('lists.status.filter')"  label-for="">
                <v-select class="style-vselect-big  font-size-16" :options="partnerStatusList" :placeholder="$t('lists.status.filter')" label="fullDescription" v-model="selectedPartnerStatus" :disabled="!fromMenu &&  ( campaignDetails == null  ||  campaignDetails.id  == null )  && campaign.campaignWithOutBags ">
                    <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                </v-select>
            </b-form-group>
        </div>


      <div v-if="!fromMenu" class="row">
        <div  class="col-12 d-flex justify-content-between">
        
        <div>
          <div class="text-secondary font-size-14 pt-2 pb-2"> {{$t('membershipApplication.label.latitude')}} </div>
            <b-form-group   class="font-weight-bold font-size-14 pr-3 "   >
              <b-form-input class="bg-light mr-2" :placeholder="$t('membershipApplication.input.latitude')"   
              v-model="campaign.latitude" ></b-form-input>      
            </b-form-group>
        </div>

        <div>
          <div class="text-secondary font-size-14 pt-2 pb-2"> {{$t('membershipApplication.label.longitude')}} </div>
          <b-form-group   class="font-weight-bold font-size-14 pr-3 "   >
            <b-form-input class="bg-light" :placeholder="$t('membershipApplication.input.longitude')"   
            v-model="campaign.longitude" ></b-form-input>   
          </b-form-group>
        </div>
            
        </div>
      </div>



      <div v-if="!fromMenu" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pr-lg-2 mt-2">
        <div class="text-secondary font-size-14 pt-2 pb-2"> {{$t('campaign.label.radius')}} </div>
              <b-form-group   class="font-weight-bold font-size-14 pr-3 "   >
                  <b-input-group   >
                      <b-form-input class="text-right col-6 " :placeholder="$t('campaign.input.radius')"  type="number" 
                      v-model="campaign.radius" ></b-form-input>                              
                  </b-input-group>
              </b-form-group>
      </div>



     


    </div>


     


















          
      </div>

      

      <div class="col-12 col-md-9">

        <div class="row mb-1">
        
        <!-- <div class="col-3"/> -->

        <div class="col-12 col-md-6 text-dark">
          <div :key="keySelectedCount"  v-if="!fromMenu">
            <div class="" v-if="campaign && campaign.selectedSectorCount">
              <span v-for="(count, sector, index) in campaign.selectedSectorCount" :key="sector">
                  <span class="font-size-16"> <strong class="">   {{ count }}  {{ sector }}(s) </strong> {{$t('campaign.text.selected')}} </span>
                  <span v-if="index < Object.keys(campaign.selectedSectorCount).length - 1">,</span>
                  
              </span>
            </div>
          </div>
          <div :key="keySectorSelectedCount"  v-else>
            <div class="" v-if="selectedSectorCount">
              <span v-for="(count, sector, index) in selectedSectorCount" :key="sector">
                  <span class="font-size-16"> <strong class="">   {{ count }}  {{ sector }}(s) </strong> {{$t('campaign.text.selected')}} </span>
                  <span v-if="index < Object.keys(selectedSectorCount).length - 1">,</span>
                  
              </span>
            </div>
          </div>
          </div>


              <div class="col-12 col-md-6 mt-md-0 mt-3 text-md-right">

                    <div>
                    <span class="mt-3 font-size-14 text-dark" v-if="campaign && campaign.selectedCitiesCount">
                        <span v-for="(count, city, index) in campaign.selectedCitiesCount" :key="city">
                          {{ count }}  {{$t('partner.text.partnerSelected')}} {{ city }}<span v-if="index < Object.keys(campaign.selectedCitiesCount).length - 1">,</span>
                        </span>
                    </span>
                    <span class="mt-3 font-size-14 text-dark" v-else>
                        <span v-for="(count, city, index) in selectedCitiesCount" :key="city">
                          {{ count }}  {{$t('partner.text.partnerSelected')}} {{ city }}<span v-if="index < Object.keys(selectedCitiesCount).length - 1">,</span>
                        </span>
                    </span>
                  </div>
                





            </div>
         
        </div>
        <div  class="map-container"   :style="{  opacity: selectedPartnerStatus ? 0.2 : 1,   pointerEvents: selectedPartnerStatus ? 'none' : 'auto' }" >
          <div id="mi_mapa" :style="{ cursor: fromMenu ? 'default' : 'crosshair'}" ></div>
        </div>

      </div>

    </div>

   <!-- <div v-if="!fromMenu"> -->
      <CampaignTargetsPartner @refrechCountSelected="refrechCountSelected" 
                            :fromMenu="fromMenu" :partnerStatus="selectedPartnerStatus ==null ? null : selectedPartnerStatus.shortCode"
                            :nearsList="this.selectedOptions == null ? null : this.selectedOptions" 
                            :sectorList="this.selectedSectorsList == null ? null : this.selectedSectorsList" 
                            :citiesId="this.selectedCity == null ? null : this.selectedCity" 
                            :countryId="this.selectedCountry == null ? null : this.selectedCountry.id"
      />
    <!-- </div> -->


      

   

      


  

     

  </div>
 

</template>




<style scoped>
  #mi_mapa {
    width: 100%;
    height: 900px;
    border: 1px solid rgb(221, 221, 221);
    border-radius: 3px;
  }
</style>

<style scoped>
.container {
  /*max-width: 1350px;
  margin: auto;*/
}

.search-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  
}

.search-input {
  width: 70%;
  padding: 10px;
  border: 2px solid #28a745;
  border-radius: 5px;
  transition: border-color 0.3s;
}

.search-input:focus {
  border-color: #155724;
  outline: none;
}

.city-select {
  width: 25%;
  padding: 10px;
  border: 2px solid #28a745;
  border-radius: 5px;
  background-color: #f8f9fa;
  transition: border-color 0.3s;
}

.city-select:focus {
  border-color: #155724;
  outline: none;
}

.map-container {
  /*margin-top: 20px;*/
  /*border: 2px solid #28a745;*/
  border: 1px solid rgb(221, 221, 221);
  border-radius: 3px;
  overflow: hidden;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}



</style>

<style >

.leaflet-div-icon {
	background: transparent;
	border: none;
}



.leaflet-marker-icon .number {
    position: relative;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    background-color: #fff; 
    border-radius: 50%; 
    font-weight: normal;
}


</style>

